import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { KAL_DIALOG_DATA, KalDate, KalDialogRef } from '@kalidea/kaligraphi';
import { BaseComponent } from 'src/app/_core/tools/base.component';
import { FactureHistoriqueModel, MutationSupprimerAvoirArgs } from 'src/graphql/generated-types';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import gql from 'graphql-tag';
import { GraphqlService } from 'src/app/_core/services/graphql.service';
import { getISODate } from 'src/app/utils/date.utils';
import { IGNORE_ALL_GRAPHQL_ERRORS } from 'src/app/_core/graphql.module';

export interface SharedDeleteCreditDialogData {
    accepted?: boolean;
    invoice?: FactureHistoriqueModel;
    deletingInvoiceId?: number;
}

@Component({
    selector: 'app-shared-delete-credit-dialog',
    templateUrl: './shared-delete-credit-dialog.component.html',
    styleUrls: ['./shared-delete-credit-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedDeleteCreditDialogComponent extends BaseComponent {

    dateControl = new UntypedFormControl(new KalDate());

    constructor(private readonly dialogRef: KalDialogRef<SharedDeleteCreditDialogComponent>,
                @Inject(KAL_DIALOG_DATA) public data: SharedDeleteCreditDialogData,
                protected readonly cdr: ChangeDetectorRef,
                private readonly graphqlService: GraphqlService) {
        super(cdr);
    }

    get invoice(): FactureHistoriqueModel {
        return this.data.invoice;
    }

    submit(): void {
        this.loading = true;

        this.watch$ = this.graphqlService.mutateOne<'SupprimerAvoir', MutationSupprimerAvoirArgs>({
            mutation: gql`
                mutation SupprimerAvoir(
                    $contexte: ContextInfosInput,
                    $idAvoir: Float
                    $dateAnnulation: DateTime
                ) {
                    SupprimerAvoir(
                        contexte: $contexte
                        idAvoir: $idAvoir
                        dateAnnulation: $dateAnnulation
                    )
                }
            `,
            variables: {
                idAvoir: this.invoice.IdFacture,
                dateAnnulation: getISODate(this.dateControl.value)
            },
            context: {
                [IGNORE_ALL_GRAPHQL_ERRORS]: true
            }
        }).pipe(
            tap(SupprimerAvoir => {
                this.loading = false;
                this.data = {
                    accepted: true,
                    deletingInvoiceId: SupprimerAvoir
                };
                this.dialogRef.close(this.data);
            }),
            catchError(err => {
                this.loading = false;
                return throwError(err);
            })
        );
    }

    cancel(): void {
        this.dialogRef.close();
    }

}
